<div class="ci-cd-container">
  <div *ngIf="isLoading" class="loader">Loading suites...</div>
  <div *ngIf="errorMsg" class="error">
    {{ errorMsg }}
  </div>
  <div *ngIf="!isLoading && suites.length > 0" class="suite-list">
    <div
      class="suite-item"
      *ngFor="let suite of suites; let i = index"
      (click)="toggleSelection(suite)"
      [class.selected]="isSelected(suite)"
      [class.overflowing]="isOverflowing(suite)"
      [class.custom-config]="hasCustomConfig(suite)"
      [featureActionState]="'CI_CD'"
    >
      <div class="suite-name">
        <span #suiteName>{{ suite.name }}</span>
        <div class="suite-actions" *ngIf="isSelected(suite)">
          <span *ngIf="hasCustomConfig(suite)" class="config-badge">Custom</span>
          <span *ngIf="!hasCustomConfig(suite)" class="config-badge default">Default</span>
          <mat-icon 
            class="config-icon" 
            (click)="editSuiteConfiguration(suite, $event)"
            matTooltip="Edit Configuration"
            [featureActionState]="'CI_CD'">
            settings
          </mat-icon>
          <mat-icon 
            class="deselect-icon" 
            (click)="deselectSuite(suite, $event)"
            matTooltip="Remove Suite"
            [featureActionState]="'CI_CD'">
            close
          </mat-icon>
         
        </div>
      </div>
    </div>
  </div>
  <p *ngIf="!isLoading && suites.length === 0 && !errorMsg" class="empty">
    No suites found.
  </p>
  
  <div class="action-buttons">
    <button (click)="resetSelection()" class="reset-btn" [featureActionState]="'CI_CD'">
      Reset Selection
    </button>
    <button 
      (click)="createEnvFileForSelectedSuites()" 
      class="generate-btn"
      [disabled]="selectedSuites.size === 0"
      [featureActionState]="'CI_CD'">
      Generate CI/CD Script
    </button>
  </div>
  
  <!-- <div class="selection-info" *ngIf="selectedSuites.size > 0">
    <p>{{ selectedSuites.size }} suite(s) selected</p>
  </div> -->
</div>